<template>
    <div class="approved-subjects__content d-flex flex-column flex-sm-row align-center justify-space-around py-3 pl-3 py-sm-5 pl-sm-5">
        <v-progress-circular v-if="loading" indeterminate color="#ccc" class="mx-auto"></v-progress-circular>
        <div v-else-if="!subjects.length" class="text-center grey--text text--darken-2">
            <v-icon class="mr-3">mdi-inbox</v-icon>
            <span>{{ $t('modules.portalalumno.dashboard.subjectsTab.inProgress.noSubjects') }}</span>
        </div>
        <template v-else>
            <div class="approved-subjects__content-grid">
              <div style="padding-bottom: 10px; margin-right: 1.5em" v-for="(subjectsByRecord, index) in subjects" :key="`${subjectsByRecord.studentRecordId}-${index}`">
                <div class="d-flex align-center table-sizing">
                    <div style="font-weight: bold; font-size: 1em">{{ subjectsByRecord.careerDescription }}</div>
                </div>
                <div class="d-flex align-center table-sizing">
                    <div class="caption font-italic">{{ $t('modules.portalalumno.dashboard.subjectsTab.inProgress.subjects') }}</div>
                </div>
                <div class="approved-subjects__content-grid-row d-flex table-sizing py-2" v-for="(subject,idx) in subjectsByRecord.subjectsInProgress" :key="`approved-${idx}`">
                    <div class="body-2 primary--text ">{{ subject.description }}</div>
                </div>
              </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { $subjects } from '../Services';
    import { mapGetters } from 'vuex';
    import authService from '../../../../core/plugins/auth.service';

    export default {
        name: 'InProgressSubjects',
        data() {
            return {
                loading: false,
            }
        },
        computed: {
            subjects() {
                if (this.cacheSubjects) return this.cacheSubjects
                else return []
            },
            ...mapGetters({
                studentRegister: 'commons/getStudentActualRegister',
                cacheSubjects: 'commons/getStudentInProcessSubjects',
                studentUserId: 'commons/getStudentUserID'
            }),
        },
        mounted(){
            if (!this.cacheSubjects) this.getData()
        },
        methods: {
            async getData(){
                try {
                    this.loading = true;
                    const studentUser = authService.isAdvisor() ? JSON.parse(localStorage.getItem('alumnoImpersonado')).id : this.studentUserId;
                    const response = await $subjects.find('in-progress', null, {params: { studentUserId: studentUser }})
                    await this.$store.dispatch('commons/setStudentInProgressSubjects', response.data);
                } catch(err) {
                    this.$store.dispatch('commons/setStudentInProgressSubjects', []);
                    throw err
                } finally {
                    this.loading = false;
                }
            }
        },
    }
</script>

<style lang="sass" scoped>

  .table-sizing
    div:nth-child(1)
      flex: 1
    div:nth-child(2)
      width: 20%
    div:nth-child(3)
      width: 15%
    div:nth-child(4)
      width: 7.7%

  .approved-subjects
    &__content
        width: 100%
        max-height: 254px
        min-height: 250px
        &-grid
          height: 100%
          max-height: 100%
          width: 100%
          overflow-y: scroll
          &-row
            border-bottom: 1px solid #ddd
            .view-subject:hover
              color: var(--v-primary-base) !important

  .resume
    .average
      .circle-blue
        width: 50px
        height: 50px
        border-radius: 50%
        background: var(--v-primary-base)

        span
          width: 50px

  @media only screen and (max-width: 600px)
    .approved-subjects
      &__content
          max-height: 254px * 2
          &-grid
            width: 100%
            &-row
              width: 100%
          .resume
            min-height: auto
</style>
